/**
 * Signal debug output is enabled when not in production
 */

export default process.env.NODE_ENV != 'production' ? true : false
